import type { CommonAction } from "@iflyrpa/share";

import { ActiomCommonParams, ActionCommonParamsSchema } from "../../types";
import { defaultParams, executeAction, formatSectionHtml } from "../../utils";
import type { CollectDetail } from "../getWeixinCollection";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";

export interface WxInteraction {
    Type: "public" | "private" | "off"; // public:评论留言, priviate: 快捷私信, off: 不开启
    Option?: {
        // public下相关设置
        Comment: "已关注7天及以上的用户" | "已关注的用户" | "所有用户"; // 评论设置
        reply: "已关注7天及以上的用户" | "已关注的用户" | "所有用户"; // 回复设置
        elect_comment: boolean; // 是否开启精选评论
        elect_reply: boolean; // 是否开启精选回复
    };
}

import { z } from "zod";

export const WxInteractionSchema = z.object({
    Type: z.enum(["public", "private", "off"]),
    Option: z
        .object({
            Comment: z.enum(["已关注7天及以上的用户", "已关注的用户", "所有用户"]),
            reply: z.enum(["已关注7天及以上的用户", "已关注的用户", "所有用户"]),
            elect_comment: z.boolean(),
            elect_reply: z.boolean(),
        })
        .optional(),
});

export const WeixinPublishParamsSchema = ActionCommonParamsSchema.extend({
    saveType: z.enum(["draft", "publish"]),
    masssend: z.boolean().optional(),
    token: z.union([z.string(), z.number()]),
    title: z.string(),
    content: z.string(),
    uuid: z.string().optional(),
    appMsgId: z.string().optional(),
    operation_seq: z.string().optional(),
    proxyLoc: z.string().optional(),
    localIP: z.string().optional(),
    huiwenToken: z.string().optional(),
    settingInfo: z.object({
        wxCover: z.string(),
        wxAuthor: z.string().optional(),
        wxAbstract: z.string().optional(),
        wxOriginalText: z.string().optional(),
        wxCopyright: z.boolean().optional(),
        wxWhitelist: z.array(z.string()).optional(),
        wxRewardTarget: z.record(z.string(), z.string()).optional(),
        wxRewardText: z.string().optional(),
        wxQuickReprint: z.boolean().optional(),
        wxNotAllowRecommend: z.boolean().optional(),
        wxCreationSource: z.array(z.string()).optional(),
        wxInteraction: WxInteractionSchema.optional(),
        timer: z.number().optional(),
        wxTopic: z.array(z.string()).optional(),
        wxCollectionInfo: z.any().optional(), // Replace `z.any()` with a specific schema if available
    }),
});

export interface WeixinPublishRuntimeOptions {
    safeQrcodeCallback?: (qrcodePath: string) => void;
}

export type WeixinPublishParams = z.infer<typeof WeixinPublishParamsSchema> & WeixinPublishRuntimeOptions;

export interface WxWhitelistUserInfo {
    nickname: string;
    openid: string; // 微信常用字段命名可能是 open_id
    username: string;
    wx_name: string;
    pic_url: string;
}

export type PublishAction = CommonAction<WeixinPublishParams, string>;

export const weixinPublish: PublishAction = async (task, _params) => {
    const params = defaultParams(_params, { masssend: false });

    // Format content HTML
    params.content = formatSectionHtml(params.content);

    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    return executeAction(mockAction, rpaAction)(task, params);
};
